import React, { useState } from "react";
import { FormSubmitCategory } from "../Components/Services";
import CommonFrom from "../../../../Common/Components/Form";
function Create() {
  const initialState = {
    loading: false,
  };
  const [state, setstate] = useState(initialState);
  const Handler = data => {
    setstate({ ...state, loading: true });
    FormSubmitCategory(data).then(() => {
      setstate({ ...state, loading: false });
    });
  };

  return (
    <CommonFrom
      form={input}
      loading={state.loading}
      submit={Handler}
      header="ایجاد دسته بندی سوال جدید"
      btnName="ثبت دسته بندی جدید"
      textbtn="لیست دسته بندی سوالات"
      linkbtn="/Admin/QuestionsSetting"
    />
  );
}

export default Create;
export const input = [
  {
    label: "عنوان ",
    size: "col-md-12 ",
    classNames: "mt-2",
    placeholder: "",
    name: "title",
    value: "",
    type: "text",
  },
  {
    label: "آیکون دسته بندی",
    size: "col-md-12",
    classNames: "mt-2",
    placeholder: "",
    name: "photo",
    input: "file",
    accept: "image/png, image/jpeg",
  },
];
